// extracted by mini-css-extract-plugin
export default {"pageLayout":"Ea-z","mainContent":"Fa-z","columnLayout":"Ga-z","columnLayoutFill":"Ha-z","columnLayoutLast":"Ia-z"};